const ENV = import.meta.env?.VITE_ENV || process.env.NODE_ENV || 'development';

export const Topics = {
  groupMessages: (wsId, groupId) => {
    const topic = `${ENV}/workspace/${wsId}/group/${groupId}/messages`;
    return topic;
  },
  groupThreads: (wsId, groupId) => {
    const topic = `${ENV}/workspace/${wsId}/group/${groupId}/threads`;
    return topic;
  },
  groupTyping: (wsId, groupId) => {
    const topic = `${ENV}/workspace/${wsId}/group/${groupId}/typing`;
    return topic;
  },
  userSidebar: (wsId, userId) => {
    const topic = `${ENV}/workspace/${wsId}/user/${userId}/sidebar`;
    return topic;
  },
  groupHuddle: (wsId, groupId) => {
    const topic = `${ENV}/workspace/${wsId}/group/${groupId}/huddle`;
    return topic;
  },
  groupHuddleParticipants: (wsId, groupId) => {
    const topic = `${ENV}/workspace/${wsId}/group/${groupId}/huddle/participants`;
    return topic;
  },
  huddleWildcard: (wsId) => {
    const topic = `${ENV}/workspace/${wsId}/group/+/huddle`;
    return topic;
  },
  huddleParticipantsWildcard: (wsId) => {
    const topic = `${ENV}/workspace/${wsId}/group/+/huddle/participants`;
    return topic;
  },
  workspacePresence: (wsId) => {
    const topic = `${ENV}/workspace/${wsId}/presence`;
    return topic;
  },
};

export class TopicManager {
  constructor() {
    this.subscriptions = new Map();
  }

  subscribe(topic, callback) {
    if (!this.subscriptions.has(topic)) {
      this.subscriptions.set(topic, { count: 0, callbacks: [] });
    }
    const sub = this.subscriptions.get(topic);
    sub.count++;
    sub.callbacks.push(callback);
    
    const isFirstSubscription = sub.count === 1;
    
    return isFirstSubscription;
  }

  unsubscribe(topic, callback) {
    if (!this.subscriptions.has(topic)) {
      return false;
    }
    const sub = this.subscriptions.get(topic);
    const idx = sub.callbacks.indexOf(callback);
    if (idx > -1) {
      sub.callbacks.splice(idx, 1);
    }
    sub.count--;
    
    if (sub.count <= 0) {
      this.subscriptions.delete(topic);
      return true;
    }
    
    return false;
  }

  getCallbacks(topic) {
    const sub = this.subscriptions.get(topic);
    const callbacks = sub ? sub.callbacks : [];
    return callbacks;
  }

  isSubscribed(topic) {
    const subscribed = this.subscriptions.has(topic) && this.subscriptions.get(topic).count > 0;
    return subscribed;
  }

  parseTopic(topic) {
    const parts = topic.split("/");
    if (parts.length < 4) {
      return null;
    }

    const result = {
      environment: parts[0],
      workspaceId: parseInt(parts[2], 10)
    };

    if (parts[3] === "presence") {
      result.type = "presence";
    } else if (parts.length >= 5 && parts[3] === "group") {
      result.groupId = parseInt(parts[4], 10);
      result.type = parts[5];
    } else if (parts.length >= 5 && parts[3] === "user") {
      result.userId = parseInt(parts[4], 10);
      result.type = parts[5];
    }

    return result;
  }

  clear() {
    this.subscriptions.clear();
  }
}

export const topicManager = new TopicManager();
